/**
 * PanelSection — convenience wrapper that combines Card[panel] + SectionHeader.
 *
 * 95% of equipment panels follow the same pattern:
 *   <Card variant="panel">
 *     <SectionHeader title=... counts=... actions=... />
 *     <grid of items>
 *   </Card>
 *
 * PanelSection collapses that into a single component so consumers only
 * have to think about the grid contents.
 */
import type { ReactNode } from 'react'
import Card from './Card'
import SectionHeader from './SectionHeader'

interface PanelSectionProps {
  title: string
  counts?: {
    available?: number
    out?: number
    oos?: number
  }
  actions?: ReactNode
  marginBottom?: number
  children: ReactNode
}

export default function PanelSection({
  title,
  counts,
  actions,
  marginBottom = 24,
  children,
}: PanelSectionProps) {
  return (
    <Card variant="panel" marginBottom={marginBottom}>
      <SectionHeader title={title} counts={counts} actions={actions} />
      {children}
    </Card>
  )
}
